const formatDate = (date: Date) =>
  date.toLocaleDateString("en-GB").replace(/\//g, "-");

export const newSessionName = () => `Untitled ${formatDate(new Date())}`;

export const untitledSessionName = (logTime?: string | null) => {
  if (!logTime) return newSessionName();
  const date = new Date(logTime.endsWith("Z") ? logTime : `${logTime}Z`);
  return isNaN(date.getTime()) ? newSessionName() : `Untitled ${formatDate(date)}`;
};
